<!--由于template上不能加key，导致有一些eslint的报错，
如果改成div会造成第一列被放到最后去，只能这样。
所以在eslintignore中忽略了本页面的检查-->
<template>
  <div>
    <el-table
      :data="data"
      :show-header="showHeader"
      :border="border"
      :height="maxHeight"
      v-loading="showLoading"
      :class="className"
      :default-sort = "defaultSort"
      :element-loading-text= "ITableLoading"
      :row-class-name="rowClassName"
      stripe
      fit
      highlight-current-row
      style="width: 100%"
      @row-click= "rowClick"
      @select="select"
      @select-all="selectAll"
      @selection-change="selectionChange"
      @filter-change="filterChange"
      @sort-change="sortChange"
      :key="tableKey"
      v-bind="$attrs"
    >
      <!--//使用v-for遍历-->
      <template
        v-for="colConfig in colConfigs"
      >
        <!--//slot 添加自定义配置项-->
        <slot
          v-if="colConfig.slot"
          :name="colConfig.slot"
        />
        <!--//component 特殊处理某一项-->
        <component
          v-else-if="colConfig.component"
          :is="config.component"
          :col-config="colConfig"
        />
        <el-table-column
          v-else
          v-bind="colConfig"
          :show-overflow-tooltip="true"
          :align="colConfig.align"
          :width="colConfig.width"
          :fixed="colConfig.fixed"
          :column-key="colConfig.columnKey"
          :filters="colConfig.filters"
          :filter-multiple="colConfig.filterMultiple"
          :sortable = "colConfig.sortable"
          :formatter = "colConfig.formatter"
        >
          <template slot-scope="scope">
              {{ tabDataFormat(colConfig,scope.row)}}
          </template>
          </el-table-column>
        </template>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'ITable',
  props: {
    colConfigs: {
      type: Array,
      default: function() {
        return []
      }
    },
    data: {
      type: Array,
      default: function() {
        return []
      }
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: [String, Number],
      default: null
    },
    showLoading: {
      type: Boolean,
      default: true
    },
    className: {
      type: String,
      default: ''
    },
    defaultSort: {
      type: Object,
      default: function() { return { } }
    },
    ITableLoading: {
      type: String,
      default: '加载中'
    },
    rowClassName: {
      type: Function,
      default: function() { return { } }
    },
    rowClick: {
      type: Function,
      default: function() { return { } }
    },
    select: {
      type: Function,
      default: function() { return { } }
    },
    selectAll: {
      type: Function,
      default: function() { return { } }
    },
    selectionChange:{
      type: Function,
      default: function() { return { } }
    },
    filterChange:{
      type: Function,
      default: function() { return { } }
    },
    sortChange:{
      type: Function,
      default: function() { return { } }
    },
    align: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    tableKey: {
      type: String,
      default: 'table1'
    }
  },
  methods:{
    //人事云数据格式化
    tabDataFormat(column,rowData){
      if(column.prop=='carRentalLong'){
        if(rowData[column.prop]=='4'){
          return "半日租";
        }else if(rowData[column.prop]=='8'){
          return "日租";
        }
        return rowData[column.prop]
      }else{
        return rowData[column.prop]
      }
    }
  }
}
</script>
<style scoped>
</style>
